import { DeviceGeneralType } from '@cobliteam/common-types';

enum DeviceAction {
  ASSOCIATE_TO_VEHICLE = 'ASSOCIATE_TO_VEHICLE',
  DISSOCIATE_FROM_VEHICLE = 'DISSOCIATE_FROM_VEHICLE',
  SEE_ASSOCIATED_VEHICLE_DETAILS = 'SEE_ASSOCIATED_VEHICLE_DETAILS',
}

const removableTypes = new Set([DeviceGeneralType.REMOVABLE, DeviceGeneralType.PLUG_AND_PLAY_IBUTTON, DeviceGeneralType.UNKNOWN]);

const installedTypes = new Set([
  DeviceGeneralType.INSTALLED,
  DeviceGeneralType.BLOCKER,
  DeviceGeneralType.IMMOBILIZER,
  DeviceGeneralType.IBUTTON,
  DeviceGeneralType.IBUTTON_IMMOBILIZER,
]);

const videoTypes = new Set([DeviceGeneralType.DASHCAM, DeviceGeneralType.MULTICAM]);

const redeCanTypes = new Set([DeviceGeneralType.CAN, DeviceGeneralType.CAN_IBUTTON, DeviceGeneralType.CAN_IBUTTON_IMMOBILIZER]);

export { DeviceAction, removableTypes, installedTypes, videoTypes, redeCanTypes };
